import React from 'react';

import type { Props } from './types';

import AppErrorBoundary from 'ui/shared/AppError/AppErrorBoundary';
import HeaderMobile from 'ui/snippets/header/HeaderMobile';

import * as Layout from './components';

const LayoutHome = ({ children }: Props) => {
  return (
    <Layout.Root content={ children }>
      <Layout.Container>
        { /* <Layout.TopRow/> */ }
        <Layout.NavBar/>
        <HeaderMobile hideSearchBar/>
        <Layout.MainArea>
          <Layout.SideBar/>
          <Layout.MainColumn
            bg={{ _light: 'blackAlpha.50', _dark: 'blackAlpha.800' }}
            paddingTop={{ base: 3, lg: 6 }}
          >
            { /* <HeaderAlert/> */ }
            <AppErrorBoundary>
              { children }
            </AppErrorBoundary>
          </Layout.MainColumn>
        </Layout.MainArea>
        { /*<Layout.Footer/>*/ }
      </Layout.Container>
    </Layout.Root>
  );
};

export default LayoutHome;
